// extracted by mini-css-extract-plugin
export default {"cookiePrivacyWrapper":"CookiePrivacyWrapper_cookiePrivacyWrapper__HTRTV","title":"CookiePrivacyWrapper_title__o55sM"};